/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import axios, { AxiosError } from 'axios';
import { useApplicationState } from '../contexts/ApplicationContext';
import { getMyApplicationsCount } from '../services';

interface Props {
  deps?: any[];
  shouldFetch?: boolean;
}

export const useApplicationsCountMine = ({
  shouldFetch = true,
  deps = [],
}: Props): {
  error: boolean;
  reason: string | undefined;
} => {
  const { setApplicationsCountMine, setLoadingUserApplications } = useApplicationState();

  const [error, setError] = React.useState<boolean>(false);
  const [reason, setReason] = React.useState<string | undefined>(undefined);
  const request = axios.CancelToken.source();

  React.useEffect(() => {
    const fetchApplicationsFull = async () => {
      if (error) {
        setError(false);
        setReason(undefined);
      }

      try {
        const data: number = await getMyApplicationsCount();

        setApplicationsCountMine(data);
        setLoadingUserApplications(false);
      } catch (reason) {
        const error = reason as AxiosError;

        setError(true);
        setReason(error.message);
      }
    };

    if (shouldFetch) {
      fetchApplicationsFull();
    }

    return () => request.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);

  return { error, reason };
};
